import { Config } from '../_config'
import { Environment } from '../_kernel/Environment'
import { QueryParams } from './QueryParams'

export class FactoryQueryParams {
  static create({ config }: { config: Config }) {
    return new FactoryQueryParams(config)
  }

  constructor(private config: Config) {}

  async params(): Promise<QueryParams> {
    const isNode = Environment.create().isNode()

    return isNode
      ? (await import('./NodeQueryParams')).NodeQueryParams.create({ config: this.config })
      : (await import('./WindowQueryParams')).WindowQueryParams.create({ config: this.config })
  }
}
